import { Directive } from '@angular/core';

@Directive({
  selector: '[appPrimaryBtn]',
  host: { class: 'app-primary-btn' },
})
export class PrimaryBtnDirective {}
